import type { BaspModule } from './types';
import type { MenuItem } from '../../stores/modules/menu/types';

/**
 * 格式化百源菜单数据，转换成前端需要的格式
 * @param menus
 */
export const baspMenusFormat = (menus: BaspModule[]): MenuItem[] => {
  if (!menus || menus.length === 0) return [];

  return menus
    .filter((item) => item.hidden !== 'Y')
    .map((item) => {
      const children = baspMenusFormat(item.childModules);

      return {
        // 需要添加name属性，解决 我的常用 不显示内容的问题
        name: item.moduleCode || '',
        path: item.helpUrl,
        id: item.moduleId,
        title: item.moduleName,
        icon: item.moduleIcon,
        children,
        order: Number(item.sort),
        hideInMenu: item.hideInMenu,
        moduleDesc: item.moduleDesc,
      };
    });
};
